import React, { useState } from 'react'
import { Ancestor } from './Amazon'
// import { rates } from '../modules/provider'
import useData from '../hooks/useData'
// import { ensureArray } from '../modules/helpers'
// import provider from '../modules/provider'
// import { Link } from 'react-router-dom'
import Loading from './Loading'
import Icon from './Icon'
import AmazonProductRow from './AmazonProductRow'
import URI from 'urijs'
import history from '../modules/history'
import { withRouter } from 'react-router-dom'
import ArticleResourcesContent from './ArticleResourcesContent'
import ArticleResourcesColumn from './ArticleResourcesColumn'

const endpoint = { value: 'FR' }
const trackingID = 'cartablecuir-21'
const locale = 'fr_FR'

// chaussures de travail - 1765055031
// militaire - 9684366031

const getTopNode = node => {
    // console.log(node)
    let candidate = node.BrowseNodeId
    if (node.Ancestors && node.Ancestors.BrowseNode) {
        candidate = getTopNode(node.Ancestors.BrowseNode)
    }
    return candidate
}

const AmazonProductList = props => {
    const ASIN_string = (props.ASIN_array && props.ASIN_array.join(',')) || ''
    const productData = useData('provider/amazon/product_details?ASIN=' + ASIN_string + '&tracking_id=' + trackingID + '&locale=' + locale, [ASIN_string.length])
    return (
        <>
            {(productData.isReady && (
                <table className='table'>
                    <tbody>
                        {productData.data.map(p => (
                            <AmazonProductRow key={`product-${p.ASIN}`} {...p} origin='amazon' originalUrl={'amazon'} displayUrl={'amazon'} />
                        ))}
                    </tbody>
                </table>
            )) ||
                (productData.isLoading && <Loading text='Fetching products from Amazon API' />) ||
                null}
        </>
    )
}

// const byCommission = (a, b) => (a.commission < b.commission && 1) || (a.commission == b.commission && '0') || -1
const AmazonCommissions = props => {
    // const node_id = props.match.params.node_id

    const search = URI(props.location.search).search(true)
    const average_min = (search && search.average_min) || null

    const [article_id, setArticleId] = useState(null)

    const topSellers = useData('provider_top_seller?scope=commissions&endpoint=' + endpoint.value + '&AssociateTag=' + trackingID + '&provider=amazon&average_min=' + average_min, [average_min])

    const [expanded, setExpanded] = useState([])

    // console.log(products.sort(byCommission))
    const toggleExpanded = id => setExpanded((~expanded.indexOf(id) && expanded.filter(i => i !== id)) || [...expanded, id])
    const onArticleChange = article_id => setArticleId(article_id)

    return (
        <>
            <ArticleResourcesContent onArticleChange={onArticleChange} article_id={article_id || undefined}>
                <div className='row'>
                    <div className={'col-md-9 col-xxl-7'}>
                        {(topSellers.isReady && (
                            <>
                                <h2>Highest Commissions Categories</h2>
                                <div className='btn-group btn-group-toggle mb-3' data-toggle='buttons'>
                                    <label className={'btn btn-secondary btn-xs' + ((~props.location.search.indexOf('average_min=2000') && ' active') || '')}>
                                        <input type='radio' name='average_min' value='product' onChange={() => history.push('/provider/amazon/commissions/?average_min=2000')} checked={~props.location.search.indexOf('average_min=2000') || false} /> &gt; 20 EUR
                                    </label>
                                    <label className={'btn btn-secondary btn-xs' + ((~props.location.search.indexOf('average_min=1000') && ' active') || '')}>
                                        <input type='radio' name='average_min' value='article' onChange={() => history.push('/provider/amazon/commissions/?average_min=1000')} checked={~props.location.search.indexOf('average_min=1000') || false} /> &gt; 10 EUR
                                    </label>
                                    <label className={'btn btn-secondary btn-xs' + ((~props.location.search.indexOf('average_min=800') && ' active') || '')}>
                                        <input type='radio' name='average_min' value='site' onChange={() => history.push('/provider/amazon/commissions/?average_min=800')} checked={~props.location.search.indexOf('average_min=800') || false} /> &gt; 8 EUR
                                    </label>
                                </div>

                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th />
                                            <th>Average commission</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {topSellers.data
                                            .sort((a, b) => (a.average_commission < b.average_commission && 1) || (a.average_commission == b.average_commission && '0') || -1)
                                            .map(i => (
                                                <React.Fragment key={`node-${i.external_provider_node_id}`}>
                                                    <tr>
                                                        <td>
                                                            <small>
                                                                <Ancestor BrowseNode={i.node.node} />
                                                            </small>
                                                        </td>
                                                        <td>
                                                            <small>{i.average_commission / 100} EUR</small>
                                                        </td>
                                                        <td>
                                                            <small>
                                                                <span className='pointer' onClick={() => toggleExpanded(i.external_provider_node_id)}>
                                                                    {(~expanded.indexOf(i.external_provider_node_id) && <Icon name='angle-up' />) || <Icon name='angle-down' />}
                                                                </span>
                                                            </small>
                                                        </td>
                                                    </tr>
                                                    {(~expanded.indexOf(i.external_provider_node_id) && (
                                                        <tr>
                                                            <td colSpan={3}>
                                                                <AmazonProductList ASIN_array={i.list.map(p => p.ASIN)} />
                                                            </td>
                                                        </tr>
                                                    )) ||
                                                        null}
                                                </React.Fragment>
                                            ))}
                                    </tbody>
                                </table>
                            </>
                        )) || <Loading text='Loading commissions data' />}
                    </div>
                    <div className='col-md-3 col-xxl-5'>{<ArticleResourcesColumn grabText={true} origin={'amazon'} originalUrl={'amazon'} displayUrl={'amazon'} />}</div>
                </div>
            </ArticleResourcesContent>
        </>
    )
}

export default withRouter(AmazonCommissions)
